window.OpenInGoogleMaps = function (lat, lng) {
     let url = `http://www.google.com/maps/place/${lat},${lng}`;
     var win = window.open(url, '_blank');
     win.focus();
}